module.exports = __webpack_public_path__ + "static/media/111.11.BDI_8130_LOEWE_1F.1045da0a.png";